const escapeChars = (name) => {
    console.log('escapeChars', name);
    const newName = name.replace(/[^a-zA-Z0-9\\.\\-]/g, '_');
    return newName;
  };
  
  export default escapeChars;